import React, { useEffect } from 'react';
import { connect } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { get_categorias } from "../../redux/actions/home";
import { useNavigate } from "react-router-dom";

function Category({ get_categorias, categories, catSlug = null }) {
    const navigate = useNavigate();

    useEffect(() => {
        if (categories.length === 0) {
            get_categorias();
        }
    }, []);


    const buttonClasses = "cursor-pointer px-3 sm:px-4 py-1 text-sm sm:text-base text-white rounded-lg hover:bg-white/30 transition no-underline font-medium";

    return (
        <>
            <div className="bg-brand-blue hover:bg-blue-700 transition-colors duration-300">
                <div className="container d-flex py-2">
                    <div className="flex-grow overflow-hidden">
                        <Swiper
                            slidesPerView="auto"
                            spaceBetween={2}
                            pagination={{ clickable: true }}
                            className="option-swiper text-center overflow-visible !min-h-0"
                        >
                            <>
                                <SwiperSlide className="item_swiper !mr-0 w-auto mx-2">
                                    <div className={buttonClasses} onClick={() => navigate('/las/ofertas')}>
                                        OFERTAS
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide className="item_swiper !mr-0 w-auto mx-2">
                                    <div className={buttonClasses} onClick={() => navigate('/los/mas-vendidos')}>
                                        MÁS VENDIDOS
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide className="item_swiper !mr-0 w-auto mx-2">
                                    <div className={buttonClasses} onClick={() => navigate('/las/novedades')}>
                                        NOVEDADES
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide className="item_swiper !mr-0 w-auto mx-2">
                                    <div
                                        className={buttonClasses}
                                        onClick={() => navigate('/vendedor')}
                                    >
                                        CONVIÉRTETE EN VENDEDOR
                                    </div>
                                </SwiperSlide>


                            </>
                        </Swiper>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = state => ({
    categories: state.Home.categories
});

export default connect(mapStateToProps, {
    get_categorias
})(Category);
